// Name: Events Body Render Definitions 

export const ACTION_ITEM_BODY_RENDER_DEF = {
    item_uid: {displayName: "Item UID"},
    last_reminder_sent_timestamp: {displayName: "Last Reminder Sent Timestamp"},
    resource_type: {displayName: "Resource Type"},
    last_updated_timestamp: {displayName: "Last Updated Timestamp"},
    created_timestamp: {displayName: "Created Timestamp"},
    item_payload: {displayName: "Item Payload"},
    reminder_count: {displayName: "Reminder Count"},
    action_item_id: {displayName: "Action Item Id"},
    resource_uid: {displayName: "Resource UID"},
    account_uid: {displayName: "Account UID"}
};

export const EVENT_BODY_RENDER_DEF = {
    spawn_action_item: {displayName: "Spawn Action Item"},
    event_type: {displayName: "Event Type"},
    event_destination: {displayName: "Event Destination"},
    last_updated_timestamp: {displayName: "Last Updated Timestamp"},
    spawn_notification: {displayName: "Spawn Notification"},
    action_item_message: {displayName: "Action Item Message"},
    created_timestamp: {displayName: "Created Timestamp"},
    deposify_only: {displayName: "Deposify Only"},
    notification_message: {displayName: "Notification Message"},
    history_message: {displayName: "History Message"},
    event_id: {displayName: "Event Id"},
    event_uid: {displayName: "Event UID"}
};

export const NOTIFICATION_BODY_RENDER_DEF = {
    event_type: {displayName: "Event Type"},
    resource_type: {displayName: "Resource Type"},
    last_updated_timestamp: {displayName: "Last Updated Timestamp"},
    created_timestamp: {displayName: "Created Timestamp"},
    resource_uid: {displayName: "Resource UID"},
    notification_uid: {displayName: "Notification UID"},
    notification_payload: {displayName: "Notification Payload"},
    event_id: {displayName: "Event Id"},
    account_uid: {displayName: "Account UID"}
};

export const EVENT_HOOK_BODY_RENDER_DEF = {
    hook_uid: {displayName: "Hook UID"},
    url: {displayName: "Url"},
    any_account_uid: {displayName: "Any Account UID"},
    event_ids: {displayName: "Event Ids"},
    account_uids: {displayName: "Account UIDs"},
    resource_uids: {displayName: "Resource UIDs"},
    created_timestamp: {displayName: "Created Timestamp"},
    any_resource_uid: {displayName: "Any Resource UID"},
    resource_types: {displayName: "Resource Types"},
    any_resource_type: {displayName: "Any Resource Type"},
    last_updated_timestamp: {displayName: "Last Updated Timestamp"},
    disabled: {displayName: "Disabled"}
};
